import storage from "store";
import expirePlugin from "store/plugins/expire";
import { getLoginUserInfo, loginByTicket, logout } from "@/api/sso";
import {
  ACCESS_TOKEN,
  TOKEN_NAME,
  USER_INFO,
  CONCATE_USER_INFO, TENANT,
} from "@/store/mutation-types";
import { getAppList } from "@/api/workbench";
import { generatorDynamicRouter } from "@/router/generator-routers";
import { getLoginUserDetailInfo } from "@/api/contacts/contactsEmp";
import { getUnreadTotal } from "@/api/message";
import { listPlatformConfig } from '@/api/serviceHall/serviceHall'
import { hasIsAdminGroup } from "@/api/perm/groupPerm";

storage.addPlugin(expirePlugin);
const user = {
  state: {
    token: "",
    name: "",
    avatar: "",
    info: {},
    contactUserInfo: {},
    appList: [],
    unreadMessageNum: undefined,
    platformConfig: [],
    isAdminGroup: undefined
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_INFO: (state, info) => {
      state.info = info;
    },
    SET_APP_LIST: (state, appList) => {
      state.appList = appList;
    },
    SET_UNREAD_MESSAGE_NUM: (state, unreadMessageNum) => {
      state.unreadMessageNum = unreadMessageNum;
    },
    SET_CONTACT_USER_INFO: (state, contactUserInfo) => {
      state.contactUserInfo = contactUserInfo;
    },
    SET_PLATFORM_CONFIG: (state, platformConfig) => {
      state.platformConfig = platformConfig
    },
    SET_IS_ADMIN_GROUP: (state, isAdminGroup) => {
      state.isAdminGroup = isAdminGroup
    },
  },

  actions: {
    LoginByTicket({ commit }, ticket) {
      return new Promise((resolve, reject) => {
        loginByTicket({ ticket: ticket }).then((response) => {
            if (response.success) {
              const result = response.data;
              storage.set(TOKEN_NAME, result.tokenName);
              storage.set(ACCESS_TOKEN, result.tokenValue, new Date().getTime() + result.tokenTimeout * 1000);
              commit("SET_TOKEN", result.tokenValue);
              storage.remove(CONCATE_USER_INFO);
              resolve(response);
            } else {
              reject(response);
            }
          }).catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        // 请求后端获取用户信息 /api/user/info
        getLoginUserInfo()
          .then((response) => {
            const { data } = response;
            commit("SET_INFO", data);
            commit("SET_NAME", data.name);
            commit("SET_AVATAR", data.avatar);
            storage.set(USER_INFO, data);

            // 下游
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户路由
    GetAppRouter({ commit }) {
      return new Promise((resolve, reject) => {
        getAppList()
          .then((response) => {
            const { data } = response;
            commit("SET_APP_LIST", data);
            const routerList = generatorDynamicRouter(data);
            // 下游
            resolve(routerList);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            console.log("logout fail:", err);
            reject(err);
          })
          .finally(() => {
            commit("SET_TOKEN", "");
            storage.remove(ACCESS_TOKEN);
            storage.remove(TOKEN_NAME);
            storage.remove(USER_INFO);
            storage.remove(CONCATE_USER_INFO)
            storage.remove(TENANT)
            const iframe = document.querySelectorAll('iframe')
            console.log(iframe);
            if(iframe.length){
              iframe.contentWindow.postMessage('clearStorage', '*');
            }
          });
      });
    },

    // 未读消息
    GetUnreadMessageNum({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUnreadTotal()
          .then((res) => {
            if (res.success) {
              commit("SET_UNREAD_MESSAGE_NUM", res.data);
              resolve();
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    //登录用户详细信息
    GetContactUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getLoginUserDetailInfo()
          .then((res) => {
            const { data } = res;
            commit("SET_CONTACT_USER_INFO", data);
            storage.set(CONCATE_USER_INFO, data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    //获取平台配置
    // 获取平台配置
    async GetPlatFormConfig ({ commit }) {
      const response = await listPlatformConfig()
      try {
        if (response.success) {
          const platformConfig = response.data
          commit('SET_PLATFORM_CONFIG', platformConfig)
        }
      } catch (e) {
        console.log(e)
      }
    },

      //判断登录用户是有平台管理员组的权限
      HasIsAdminGroup({commit}) {
          return new Promise((resolve, reject) => {
              hasIsAdminGroup().then((res) => {
                  commit("SET_IS_ADMIN_GROUP", res.data.data);
                  resolve(res.data);
              })
                  .catch((error) => {
                      reject(error);
                  });
          });
      },
  },
};

export default user;
